import { useState } from 'react'
import useIntersectionObserver from '@helpers/hooks/useIntersectionObserver'

type IsStickyElementProps = {
  elementIdentifier: string
  threshold?: [number, number]
  isStickyDefault?: boolean
}
function useIsStickyElement({
  elementIdentifier,
  threshold = [0, 1],
  isStickyDefault = false
}: IsStickyElementProps) {
  const [isSticky, setIsSticky] = useState(isStickyDefault)

  const onIntersect: IntersectionObserverCallback = ([entry]) => {
    setIsSticky(entry.intersectionRatio < 1)
  }

  useIntersectionObserver({
    elementIdentifier,
    options: { threshold },
    onIntersect
  })

  return isSticky
}

export default useIsStickyElement
